var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TransactionJourneyConfigURL } from "@adapters/infrastructures/urlConfig/Markets/otcURL";
import { DpDetailsMapper } from "@domains/features/Markets/OTC/mapper/DpDetailsMapper";
import { getQuery } from "@frameworks/NCD/Utils/getQuery";
var TransactionJourneyRepository = /** @class */ (function () {
    function TransactionJourneyRepository(http) {
        this.http = http;
    }
    TransactionJourneyRepository.prototype.validateSetUpFeesAmount = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.validateSetUpFees);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getFixingDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.fixingDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getIsinClientDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.isinClientDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getBankCode = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.validateBankDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.draftOrderDeclarations = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.draftOrderDeclarations);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.saveOrder = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.saveOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.saveDocs = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.saveDocs);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getEmpPartnerDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getEmpPartnerDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getBankDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getBankDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getClientSearch = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getClientSearch +
                            "?" +
                            "".concat(getQuery(requestPayload)));
                        headers = new Headers();
                        headers.append("ApiKey", process.env.ELASTIC_SEARCH_CONFIG);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                headers: headers,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getRecentClientSearch = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getRecentClientSearch);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.saveRecentClientSearch = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.saveRecentClientSearch);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getDpDetailsList = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.dpDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, DpDetailsMapper(data)];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.saveDraftOrder = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.draftOrder);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getDraftOrderDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.draftOrdersDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.previewDraftDocs = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.previewDraftDocs);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.deletedDraftDocs = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.deleteDraftDocs);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.saveDraftDocs = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getDirtyPriceDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.getDirtyPriceDetails = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.getDirtyPriceDetails);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.validateQuantity = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.validateQuantity);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TransactionJourneyRepository.prototype.validateDirtyPrice = function (requestPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(TransactionJourneyConfigURL.validateDirtyPrice);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                avoidAppID: true,
                                body: requestPayload,
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return TransactionJourneyRepository;
}());
export default TransactionJourneyRepository;
